import {
  Code2, Palette, TestTube, RefreshCw,
  Cloud, Container, GitBranch, ShieldCheck, Headphones,
  Database, Brain, Bot, Compass, Users,
} from 'lucide-react';

export const servicePillars = [
  {
    name: 'Build',
    description: 'Design and engineer world-class software products.',
    services: [
      {
        icon: Code2,
        title: 'Custom Software Development',
        summary: 'SaaS platforms, legacy modernization, full-stack engineering',
        features: [
          'Java, .NET, Python, Node.js, Go backend engineering',
          'React, Next.js, Angular, Vue.js frontend development',
          'Native & cross-platform mobile (Flutter, React Native)',
          'Microservices, REST & GraphQL APIs, event-driven architecture',
        ],
      },
      {
        icon: Palette,
        title: 'Product Strategy & UX Design',
        summary: 'Discovery, MVP definition, design systems, accessibility',
        features: [
          'User research, personas, and design thinking workshops',
          'MVP definition and data-driven product roadmaps',
          'Scalable design systems and component libraries',
          'Accessibility-first approach with WCAG compliance',
        ],
      },
      {
        icon: TestTube,
        title: 'Quality Engineering',
        summary: 'Functional automation, performance testing, security testing',
        features: [
          'UI automation for web and mobile applications',
          'API testing, regression, and cross-browser validation',
          'Load, stress, and chaos testing for resilience',
          'Penetration testing and compliance evidence support',
        ],
      },
      {
        icon: RefreshCw,
        title: 'Business Process Transformation',
        summary: 'Workflow re-engineering, automation with human oversight',
        features: [
          'End-to-end workflow redesign and optimization',
          'Intelligent automation with human-in-the-loop',
          'Sustainable operational excellence frameworks',
          'Measurable efficiency gains and ROI tracking',
        ],
      },
    ],
  },
  {
    name: 'Run',
    description: 'Deploy, secure, and operate at enterprise scale.',
    services: [
      {
        icon: Cloud,
        title: 'Cloud Engineering',
        summary: 'AWS, Azure, GCP, IaC, FinOps, multi-cloud strategies',
        features: [
          'Cloud-native architecture and migration assessment',
          'Terraform, Pulumi, CloudFormation infrastructure as code',
          'Multi-cloud and hybrid strategies with FinOps optimization',
          'Landing zone setup, secure network design, identity architecture',
        ],
      },
      {
        icon: Container,
        title: 'Containerization & Orchestration',
        summary: 'Docker, Kubernetes, EKS/AKS/GKE, Helm, zero-downtime',
        features: [
          'Docker containerization and Kubernetes orchestration',
          'Amazon EKS, Azure AKS, Google GKE deployment',
          'Helm chart design for reproducible deployments',
          'Auto-scaling, self-healing, and zero-downtime updates',
        ],
      },
      {
        icon: GitBranch,
        title: 'DevOps & SRE',
        summary: 'CI/CD pipelines, SLO/SLA, chaos engineering, 24x7 ops',
        features: [
          'GitHub Actions, GitLab CI, Jenkins pipeline automation',
          'Blue-green and canary deployment strategies',
          'SLO/SLA design, observability, and incident management',
          '24x7 monitoring, performance tuning, and disaster recovery',
        ],
      },
      {
        icon: ShieldCheck,
        title: 'Security & Compliance',
        summary: 'Secure SDLC, SAST/DAST, cloud security, ISO/SOC/GDPR',
        features: [
          'Secure Software Development Lifecycle (SSDLC)',
          'SAST, DAST, SCA tools and vulnerability management',
          'Cloud security posture management and zero-trust architecture',
          'ISO 27001, SOC 2, GDPR, HIPAA compliance enablement',
        ],
      },
      {
        icon: Headphones,
        title: 'Managed Services',
        summary: 'L2/L3 support, cloud operations, continuous improvement',
        features: [
          'Application management with L2/L3 production support',
          'Infrastructure monitoring, security patching, backup & DR',
          'Cost governance across all cloud platforms',
          'Continuous improvement, bug fixes, and enhancements',
        ],
      },
    ],
  },
  {
    name: 'Intelligentize',
    description: 'Harness data and AI for competitive advantage.',
    services: [
      {
        icon: Database,
        title: 'Data Engineering & Analytics',
        summary: 'ETL/ELT, data lakes, real-time streaming, BI dashboards',
        features: [
          'Data lake and warehouse architecture design',
          'ETL/ELT pipeline development and optimization',
          'Real-time streaming with Kafka, Kinesis, and Flink',
          'Enterprise dashboards, KPI frameworks, and embedded analytics',
        ],
      },
      {
        icon: Brain,
        title: 'AI & Intelligent Systems',
        summary: 'LLM/RAG, guardrails, governance, model deployment',
        features: [
          'LLM integration with RAG-based grounded responses',
          'AI guardrails, outcome moderation, and explainability',
          'Governance frameworks for regulatory compliance',
          'Custom model deployment, fine-tuning, and lifecycle management',
        ],
      },
      {
        icon: Bot,
        title: 'Agentic AI & Automation',
        summary: 'Virtual agents, copilots, IDP, workflow orchestration',
        features: [
          'Autonomous AI agents with multi-step reasoning',
          'Enterprise copilots and knowledge-based systems',
          'Intelligent document processing and decision systems',
          'API orchestration across multi-tenant platforms',
        ],
      },
      {
        icon: Compass,
        title: 'Strategic Consulting & Advisory',
        summary: 'Digital transformation, cloud optimization, AI governance',
        features: [
          'Technology strategy and digital transformation roadmaps',
          'Cloud cost optimization and FinOps advisory',
          'Security and compliance framework design',
          'AI governance, ethics, and responsible deployment',
        ],
      },
    ],
  },
  {
    name: 'Scale',
    description: 'Extend your team with elite engineering talent, on demand.',
    services: [
      {
        icon: Users,
        title: 'Staff Augmentation',
        summary: 'On-demand engineers, architects, and specialists embedded in your team',
        features: [
          'Senior full-stack, backend, frontend, and mobile engineers',
          'Cloud architects, DevOps engineers, and SRE specialists',
          'AI/ML engineers, data scientists, and data engineers',
          'QA automation engineers and security specialists',
          'Flexible engagement models — short-term sprints to long-term pods',
          'Rapid onboarding with 48-hour candidate shortlisting',
          'Dedicated delivery manager and performance tracking',
          'Seamless timezone overlap with Amsterdam + Chennai hubs',
        ],
      },
    ],
  },
];
